<template>
    <div>
        <b-row class="mb-2">
            <b-col class="text-right">
                <b-button-group>
                    <b-button  v-if="Core.Session.AuthUser.can('binder_management_post')" @click="add" class="btn btn-light">{{Core.Definition.getDefinition('Nouvelle signature')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'BinderPDFSignatureContainer',
        components: {
        },
        mounted() {
        },
        data () {
            return {
                Core: window.Core
            }
        },
        methods: {
            add() {
                if (this.$route.fullPath === window.Core.Definition.getDefinition('signatures/nouvelle-signature')) {
                    location.reload()
                } else {
                    this.$router.push(window.Core.Definition.getDefinition('signatures/nouvelle-signature'))
                }
            }
        }
    }
</script>
